var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"caring-title",style:({ color: _vm.color })},[_c('span',{staticClass:"caring-title-icon",style:(_vm.iconStyle)}),_vm._t("default",function(){return [_c('span',[_vm._v(_vm._s(_vm.text))])]}),_vm._t("value")],2)}
var staticRenderFns = []

export { render, staticRenderFns }